export const contentDocumentLinkFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  ContentDocumentId: 'contentDocument'
}

export interface ContentDocumentLink {
  id: string
  contentDocument: string
}
